(function () {
  "use strict";

  var policyBody = document.querySelector(".shopify-policy__body .rte");
  if (!policyBody) return;

  var path = (window.location.pathname || "").toLowerCase();
  var isContact = path.indexOf("contact-information") !== -1;

  // ---------------------------------------------------------------
  // Default behaviour for ALL policy pages: auto-mailto plain emails.
  // ---------------------------------------------------------------
  if (!isContact) {
    var EMAIL_RE = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    var walker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (node.parentNode.closest("a")) return;
      var text = node.nodeValue;
      if (!EMAIL_RE.test(text)) return;
      EMAIL_RE.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var lastIdx = 0;
      var m;
      while ((m = EMAIL_RE.exec(text)) !== null) {
        if (m.index > lastIdx) {
          frag.appendChild(document.createTextNode(text.slice(lastIdx, m.index)));
        }
        var a = document.createElement("a");
        a.href = "mailto:" + m[1];
        a.textContent = m[1];
        frag.appendChild(a);
        lastIdx = m.index + m[1].length;
      }
      if (lastIdx < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIdx)));
      }
      node.parentNode.replaceChild(frag, node);
    });
    return;
  }

  // ---------------------------------------------------------------
  // Contact-information specific: replace text with logo + 4 contact buttons (title + info)
  // ---------------------------------------------------------------
  // Avoid double-render on hot reload
  if (policyBody.querySelector(".pexter-contact-card")) return;

  var email = "info@pexter.com";

  // Wipe existing text — we replace it with our card
  policyBody.innerHTML = "";

  // Build the contact card
  var card = document.createElement("div");
  card.className = "pexter-contact-card";

  var logo = document.createElement("img");
  logo.src =
    document.documentElement.getAttribute("data-pexter-wordmark") ||
    "/cdn/shop/t/1/assets/pexter-wordmark.svg";
  // Fallback: try Shopify's asset_url-style path discovery via existing pattern
  // We populate this from theme.liquid so we always get the right CDN path.
  logo.alt = "PEXTER";
  logo.className = "pexter-contact-card__logo";
  card.appendChild(logo);

  var actions = [
    {
      key: "email",
      url: "mailto:" + email,
      title: "Email",
      info: email,
      label: "Email PEXTER",
      svg:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="2.5" y="4.5" width="19" height="15" rx="2"/>' +
        '<path d="M3 6.5l9 6.5 9-6.5"/>' +
        "</svg>",
    },
    {
      key: "instagram",
      url: "https://www.instagram.com/getpexter/",
      title: "Instagram",
      info: "@getpexter",
      label: "Pexter on Instagram",
      svg:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="2.5" y="2.5" width="19" height="19" rx="5" ry="5"/>' +
        '<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>' +
        '<line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>' +
        "</svg>",
    },
    {
      key: "tiktok",
      url: "https://www.tiktok.com/@getpexter",
      title: "TikTok",
      info: "@getpexter",
      label: "Pexter on TikTok",
      svg:
        '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.7 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.74-.1z"/>' +
        "</svg>",
    },
    {
      key: "facebook",
      url: "https://www.facebook.com/profile.php?id=100091076050882",
      title: "Facebook",
      info: "Pexter",
      label: "Pexter on Facebook",
      svg:
        '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12z"/>' +
        "</svg>",
    },
  ];

  var ul = document.createElement("ul");
  ul.className = "pexter-contact-card__icons";
  actions.forEach(function (a) {
    var li = document.createElement("li");
    var link = document.createElement("a");
    link.href = a.url;
    link.setAttribute("aria-label", a.label);
    link.className = "pexter-contact-card__icon";
    if (a.key !== "email") {
      link.target = "_blank";
      link.rel = "noopener";
    }
    link.innerHTML =
      '<span class="pexter-contact-card__icon-circle">' + a.svg + "</span>" +
      '<span class="pexter-contact-card__text">' +
      '<span class="pexter-contact-card__title">' + a.title + "</span>" +
      '<span class="pexter-contact-card__info">' + a.info + "</span>" +
      "</span>";
    li.appendChild(link);
    ul.appendChild(li);
  });
  card.appendChild(ul);

  policyBody.appendChild(card);
})();
